import { cycleCountsOverhaulApi } from "./cycleCountsOverhaul";

export const {
  useGetOverhaulIncompleteCycleCountsQuery,
  useGetCycleCountFilterCountsQuery,
  usePostStartCycleCountingMutation,
  usePostCompleteCountingTaskMutation,
  usePutCycleCountFrequencyMutation
} = cycleCountsOverhaulApi;
